import React, { createContext, useState } from 'react';

export const PaneContext = createContext({});

export const PaneProvider = ({ children }) => {
  const [state, setState] = useState({
    newPatronMode: false,
    cameraOn: false,
    previewPanePhoto: '',
    activeTab: 0,
  });

  const toggleCamera = (value) => {
    if (value !== true || value !== false) {
      setState((s) => ({ ...s, cameraOn: !s.cameraOn }));
    } else {
      setState((s) => ({ ...s, cameraOn: value }));
    }
  };

  const toggleNewPatronMode = (value) => {
    if (value === true) {
      setState((s) => ({ ...s, newPatronMode: true }));
    } else if (value === false) {
      setState((s) => ({ ...s, newPatronMode: false }));
    } else {
      setState((s) => ({ ...s, newPatronMode: !s.newPatronMode }));
    }
  };

  const updatePreviewPane = (url) => {
    setState((s) => ({ ...s, previewPanePhoto: url }));
  };

  const changeTab = (value) => {
    setState((s) => ({ ...s, activeTab: value }));
  };

  return (
    <PaneContext.Provider
      value={{
        ...state,
        toggleCamera,
        toggleNewPatronMode,
        updatePreviewPane,
        changeTab,
      }}
    >
      {children}
    </PaneContext.Provider>
  );
};
